import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {Form, Formik} from 'formik';
import moment from 'jalali-moment';
import React, {useState} from 'react';
import FormikInput from '../../../components/formikFileds/input';

import {useLocation, useNavigate, useParams} from 'react-router-dom';
import CustomButton from '../../../components/mazraeKit/customButton';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import usePostPromotionCartToCart from '../../../services/hookService/postPromotionCartToCart/usePostPromotionCartToCart';

import classNames from 'classnames';
import Modal from '../../../components/mazraeKit/modal';
import CardToCard from '../UpgradePlanCardToCard/CardToCard';
import CalenderWrapperBottomSheet from './CalenderWrapperBottomSheet';
import {validatoinHelper} from './helper';

interface NavigateState {
  type: string;
  paymentType: string;
  choosed: Array<IPromotedAdvertisement>;
}
interface NavigateLocation {
  state: NavigateState;
}
const UpgradePrmotionCardToCard = () => {
  const {guid} = useParams();
  const {state}: NavigateLocation = useLocation();
  const navigate = useNavigate();

  const [isOpenBottomSheet, setIsOpenBottomSheet] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File>();
  const [isSuccessModal, setisSuccessModal] = useState(false);

  const {isLoading, mutate} = usePostPromotionCartToCart({
    onSuccess: () => {
      setisSuccessModal(true);
    },
  });

  return (
    <div className="flex flex-col justify-between w-full h-full">
      <CustomHeader
        title={'پرداخت کارت به کارت'}
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
        onClick={() => {
          navigate(-1);
        }}
      />
      <div className="flex flex-col w-full h-full gap-3 px-3 py-2 pt-4 overflow-y-auto">
        <CardToCard bankName="پارسیان" />

        <p className="text-md text-justify	mt-4 font-Regular text-gray-900 leading-[24px]">
          می‌توانید با استفاده از شماره کارت درج شده، مبلغ مورد نظر را کارت به
          کارت کرده و در نهایت عکس رسید دریافت شده از دستگاه خودپرداز و یا بانک
          را بارگذاری کنید. سپس اطلاعات مندرج رسید را وارد کرده و دکمه ثبت
          اطلاعات را بزنید.
        </p>

        <Formik
          initialValues={{
            paid_amount: '',
            tracking_code: '',
            payment_date: '',
            payment_receipt_image: '',
          }}
          validationSchema={validatoinHelper()}
          onSubmit={values => {
            selectedImage &&
              mutate({
                tracking_code: values.tracking_code,
                payment_date: moment
                  .from(values.payment_date, 'fa', 'YYYY/M/D')
                  .format('YYYY-M-D'),
                advertisement_guid: guid || '',
                package_guids: state.choosed.map(item => item.guid).toString(),
                package_type: state.paymentType,
                paid_amount: values.paid_amount,
                payment_receipt_image: selectedImage,
              });
          }}
        >
          {({values, errors, touched, setFieldValue}) => (
            <Form className="flex flex-col w-full pb-3">
              <div className="flex flex-col items-center w-full gap-4">
                {selectedImage ? (
                  <div className="flex flex-col w-full">
                    <div className="w-full min-h-[128px] max-h-[128px] rounded-[8px] border-dashed border-[2px] border-gray-700 relative">
                      <div
                        className="absolute flex items-center justify-center p-1 text-white bg-white rounded-full right-2 top-2"
                        onClick={() => {
                          setFieldValue('payment_receipt_image', '');
                          setSelectedImage(undefined);
                        }}
                      >
                        <SpanIcon className="text-xl text-red-600 icon-nameDelete" />
                      </div>
                      <img
                        className="object-fill w-full h-full"
                        src={URL.createObjectURL(selectedImage)}
                        alt="upload_images"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col w-full">
                    <div className="w-full min-h-[128px] rounded-[8px] border-dashed border-[2px] border-gray-700">
                      <label
                        htmlFor="image_upload"
                        className="flex flex-col items-center justify-center w-full h-full gap-2 text-gray-900"
                      >
                        <SpanIcon className="text-xl icon-nameDocument" />
                        <p className="text-xs font-Regular">
                          بارگذاری تصویر رسید پرداخت
                        </p>
                      </label>
                      <input
                        id="image_upload"
                        type="file"
                        className="hidden"
                        onChange={event => {
                          event.target.files &&
                            setFieldValue('payment_receipt_image', 'added');
                          event.target.files &&
                            setSelectedImage(event.target.files[0]);
                        }}
                        accept=".jpg, .jpeg"
                      />
                      {errors.payment_receipt_image &&
                        touched.payment_receipt_image && (
                          <p className="pt-2 pb-0 mb-0 text-xs text-red-500 font-Regular">
                            {errors.payment_receipt_image}
                          </p>
                        )}
                    </div>
                  </div>
                )}
                <div className="flex-col w-full">
                  <button
                    className={classNames(
                      'w-full flex h-[50px] rounded-[8px] border-[1px]  text-gray-600 items-center gap-2 px-2 justify-start ',
                      {
                        'border-green-600':
                          !errors.payment_date &&
                          !touched.payment_date &&
                          values.payment_date,
                        'border-red-500':
                          errors.payment_date && touched.payment_date,
                        'border-gray-400':
                          !errors.payment_date &&
                          !touched.payment_date &&
                          !values.payment_date,
                      },
                    )}
                    type="button"
                    onClick={() => setIsOpenBottomSheet(true)}
                  >
                    <SpanIcon className="flex items-center h-full icon-nameCalendar" />
                    <p className="flex items-center h-full p-0 m-0 text-md">
                      {values.payment_date ? (
                        <>{moment(values.payment_date).format('YYYY/MM/DD')}</>
                      ) : (
                        <>
                          تاریخ واریز<span className="text-red-700">*</span>
                        </>
                      )}
                    </p>
                  </button>
                  {errors.payment_date && touched.payment_date && (
                    <p className="pt-2 pb-0 mb-0 text-xs text-red-500 font-Regular">
                      {errors.payment_date}
                    </p>
                  )}
                </div>
                <FormikInput
                  name="paid_amount"
                  label="مبلغ پرداخت شده"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('paid_amount', e.target.value);
                  }}
                  required={!values.paid_amount}
                />
                <FormikInput
                  name="tracking_code"
                  label="کد پیگیری"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('tracking_code', e.target.value);
                  }}
                  required={!values.tracking_code}
                />
                <CustomButton
                  type="submit"
                  title="ثبت اطلاعات پرداخت"
                  isLoading={isLoading}
                  className="text-white text-md font-Medium rounded-[8px] bg-farm-shop-500 flex justify-center items-center h-[48px] w-full"
                />
              </div>
              <CalenderWrapperBottomSheet
                addDateHandler={(value: string) => {
                  setFieldValue('payment_date', value);
                }}
                isOpenBottomSheet={isOpenBottomSheet}
                setIsOpenBottomSheet={setIsOpenBottomSheet}
              />
            </Form>
          )}
        </Formik>
      </div>
      <Modal
        isOpen={isSuccessModal}
        setIsOpen={() => {
          navigate(`/my-ads/${state.type}/${guid}`);
          setisSuccessModal(false);
        }}
      >
        <div className="w-[320px] flex flex-col p-3 gap-3">
          <div className="flex items-center justify-between">
            <div className="flex w-[90%] justify-center">
              <SpanIcon className="icon-nameCheck-circle text-xxl text-farm-shop-500" />
            </div>
            <button
              onClick={() => {
                navigate(`/my-ads/${state.type}/${guid}`);
                setisSuccessModal(false);
              }}
            >
              <SpanIcon className="icon-nameClose-remove text-xl text-gray-700 w-[10%]" />
            </button>
          </div>
          <h5 className="flex justify-center w-full text-gray-950">
            اطلاعات پرداخت ثبت شد
          </h5>
          <p className="w-full p-0 m-0 text-gray-700 text-md font-Regular">
            پس از بررسی اطلاعات پرداخت، آگهی شما ارتقا پیدا خواهد کرد.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default UpgradePrmotionCardToCard;
